module.exports = __webpack_public_path__ + "static/Instrucciones-48793c6aa3d607e3addf6a2ad9ac69c2.png";